import BreadCrumb from "Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { Link } from "Common/SafeLink";
import { useParams } from "react-router-dom";
import Loadr from "Common/Components/Loader";
import { toast, ToastContainer } from "react-toastify";
import { fetchGameById } from "services/apiGames";

const RADIO_LINK_BASE_URL = "https://www.betaplay.ng";

const ViewGame = () => {
  const { gameId } = useParams();
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!gameId) return;
    setLoading(true);
    fetchGameById(gameId)
      .then((data) => setGame(data))
      .catch((err) => toast.error(err.message || "Failed to load game"))
      .finally(() => setLoading(false));
  }, [gameId]);

  if (loading) {
    return (
      <React.Fragment>
        <BreadCrumb title="View Game" pageTitle="Games" />
        <div className="flex justify-center py-12">
          <Loadr />
        </div>
      </React.Fragment>
    );
  }

  if (!game) {
    return (
      <React.Fragment>
        <BreadCrumb title="View Game" pageTitle="Games" />
        <div className="card">
          <div className="card-body">
            <p className="text-slate-500">Game not found.</p>
            <Link to="/games" className="text-custom-500 hover:underline mt-2 inline-block">
              Back to Games
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <BreadCrumb title="View Game" pageTitle="Games" />
      <ToastContainer closeButton={false} limit={1} />
      <div className="card">
        <div className="card-body">
          <div className="flex items-center justify-between mb-4">
            <Link to="/games" className="text-slate-500 hover:text-custom-500">
              ← Back to Games
            </Link>
            <Link
              to={`/games/edit/${game.id}`}
              className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600 btn-sm"
            >
              Edit Game
            </Link>
          </div>
          <h5 className="mb-4">Game details</h5>
          <dl className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Game ID</dt>
              <dd className="mt-1 text-base text-slate-900 dark:text-white">{game.referenceId}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Title</dt>
              <dd className="mt-1 text-base text-slate-900 dark:text-white">{game.title}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Game Type</dt>
              <dd className="mt-1 text-base text-slate-900 dark:text-white">{game.type}</dd>
            </div>
            {game.type === "RADIO" && game.radioSlug && (
              <div className="md:col-span-2">
                <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Radio link name</dt>
                <dd className="mt-1 text-base text-slate-900 dark:text-white">{game.radioSlug}</dd>
                <div className="mt-2 p-3 rounded-lg bg-slate-100 dark:bg-zink-600 border border-slate-200 dark:border-zink-500 flex flex-wrap items-center gap-2">
                  <code className="text-sm text-custom-600 dark:text-custom-400 break-all">
                    {RADIO_LINK_BASE_URL}/radiogames/{game.radioSlug}
                  </code>
                  <button
                    type="button"
                    className="btn btn-sm bg-custom-500 text-white"
                    onClick={() => {
                      navigator.clipboard.writeText(`${RADIO_LINK_BASE_URL}/radiogames/${game.radioSlug}`);
                      toast.success("Link copied to clipboard");
                    }}
                  >
                    Copy link
                  </button>
                </div>
              </div>
            )}
            <div>
              <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Amount per ticket</dt>
              <dd className="mt-1 text-base text-slate-900 dark:text-white">₦{Number(game.amountPerSlot).toLocaleString()}</dd>
            </div>
            <div className="md:col-span-2">
              <dt className="text-sm font-medium text-slate-500 dark:text-zink-200">Description</dt>
              <dd className="mt-1 text-base text-slate-900 dark:text-white whitespace-pre-wrap">{game.description || "—"}</dd>
            </div>
          </dl>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewGame;
